export const formatDate = (value: string | number) => {
  const d = new Date(value);

  const h = d.getHours();
  const m = d.getMinutes();
  const s = d.getSeconds();

  if (h === 0 && m === 0 && s === 0) {
    return d.toLocaleDateString(undefined);
  }
  if (m === 0 && s === 0) {
    return d.toLocaleDateString(undefined, { hour: "numeric", hour12: true });
  }
  if (s === 0) {
    return d.toLocaleDateString(undefined, {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }

  return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
};
